import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

export const fetchOverview = (region, asset_class) =>
  api.get("/sentiment/overview", { params: { region, asset_class } }).then((r) => r.data);

export const fetchHeatmap = (region, asset_class) =>
  api.get("/sentiment/heatmap", { params: { region, asset_class, limit: 60 } }).then((r) => r.data);

export const fetchTickers = (region, asset_class) =>
  api.get("/tickers", { params: { region, asset_class, limit: 16 } }).then((r) => r.data);

export const fetchAsset = (symbol) =>
  api.get(`/sentiment/asset/${encodeURIComponent(symbol)}`).then((r) => r.data);

export const fetchAssetHistory = (symbol, days = 180) =>
  api.get(`/sentiment/asset/${encodeURIComponent(symbol)}/history`, { params: { days } }).then((r) => r.data);

export const fetchAssetNews = (symbol, limit = 10) =>
  api.get(`/news/asset/${encodeURIComponent(symbol)}`, { params: { limit }, timeout: 60000 }).then((r) => r.data);

export const fetchForecast = (symbol) =>
  api.get(`/forecast/asset/${encodeURIComponent(symbol)}`, { timeout: 120000 }).then((r) => r.data);

export const fetchNews = (region) =>
  api.get("/news", { params: { region, limit: 12 } }).then((r) => r.data);

export const fetchUniverse = (region, asset_class) =>
  api.get("/universe", { params: { region, asset_class } }).then((r) => r.data);

export const aiSummary = (payload) => api.post("/ai/summary", payload).then((r) => r.data);

export const searchSymbols = (q, limit = 10) =>
  api.get("/search", { params: { q, limit }, timeout: 8000 }).then((r) => r.data);

export const fetchRegionalNewsSummary = (region) =>
  api.get("/news/regional-summary", { params: { region, limit: 10 }, timeout: 60000 }).then((r) => r.data);

export const recommendFunds = (payload) =>
  api.post("/funds/recommend", payload, { timeout: 90000 }).then((r) => r.data);

// Luxury watches segment
export const fetchWatchBrands = (params = {}) =>
  api.get("/watches/brands", { params }).then((r) => r.data);

export const fetchWatchNews = (limit = 20) =>
  api.get("/watches/news", { params: { limit }, timeout: 60000 }).then((r) => r.data);

export const fetchWatchIndex = (range = "1y") =>
  api.get("/watches/index", { params: { range }, timeout: 30000 }).then((r) => r.data);

export const fetchWatchHype = () =>
  api.get("/watches/hype", { timeout: 30000 }).then((r) => r.data);

export const fetchWatchSentiment = () =>
  api.get("/watches/sentiment", { timeout: 60000 }).then((r) => r.data);

// AI Insights blog
export const fetchInsights = (warm = false) =>
  api.get("/insights", { params: warm ? { warm: 1 } : {}, timeout: 30000 }).then((r) => r.data);

export const fetchInsight = (slug) =>
  api.get(`/insights/${encodeURIComponent(slug)}`, { timeout: 30000 }).then((r) => r.data);

export const generateInsight = (region) =>
  api.post(`/insights/generate?region=${encodeURIComponent(region)}`, null, { timeout: 120000 }).then((r) => r.data);

// Programmatic screener
export const fetchMovers = (params = {}) =>
  api.get("/screener/movers", { params, timeout: 60000 }).then((r) => r.data);

export const fetchSectors = (region = "Global") =>
  api.get("/screener/sectors", { params: { region }, timeout: 60000 }).then((r) => r.data);

export const fetchSectorDetail = (slug, region = "Global") =>
  api.get(`/screener/sector/${encodeURIComponent(slug)}`, { params: { region }, timeout: 60000 }).then((r) => r.data);

export const compareAssets = (a, b) =>
  api.get(`/compare/${encodeURIComponent(a)}/${encodeURIComponent(b)}`, { timeout: 60000 }).then((r) => r.data);

// Nifty options predictor
export const fetchNiftyOptionsPredictor = (expiry = "weekly") =>
  api.get("/options/nifty-predictor", { params: { expiry }, timeout: 30000 }).then((r) => r.data);
